import { Auth } from "aws-amplify";

import Cognito from "../Amplify";

async function sair() {
  await Cognito.signOut();
  await Auth.signOut();
  window.location.href = "/";
}

async function getCurrentAuthenticatedUser() {
  return await Auth.currentAuthenticatedUser();
}

export { sair, getCurrentAuthenticatedUser };
